import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Projects from '../components/Projects';
import WhyChooseUs from '../components/WhyChooseUs';
import About from '../components/About';
import Process from '../components/Process';
import Contact from '../components/Contact';
import CTA from '../components/CTA';

const HomeLight = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Luxe Cabinetry | Light Edition";
  }, []);

  return (
    <>
      <Hero theme="light" />
      <Services theme="light" />
      <Projects />
      <WhyChooseUs />
      <About />
      <Process theme="light" />
      <CTA />
      <Contact />
    </>
  );
};

export default HomeLight;
